import { render, staticRenderFns } from "./adjustment-input.vue?vue&type=template&id=896e1a16"
import script from "./adjustment-input.vue?vue&type=script&lang=js"
export * from "./adjustment-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports